export default {"src":"/_next/static/media/star.09202ed9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};